<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

  export default {
    name: "Header",

  };
</script>


<style lang="less">
  html{
    background-color: #F5F5F5;
  }
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    overflow: hidden;
  }

  /*自定义颜色*/
  .origin{
    background-color: #F57523!important;
    color: #fff!important;
  }
  .origin2{
    background-color: #e29759 !important;
    color: #fff!important;
  }
  /*自定义弹窗*/
  .myToast{
    padding: 23px 24px 24px;
    font-size: 16px;
    background-color:#F57523;
    border-radius:2px;
    color: #fff;
    line-height: 21px;
  }
  .myToastMob{
    padding: .32rem .24rem .31rem;
    font-size: .26rem;
    background-color:#F57523;
    border-radius:.02rem;
    color: #fff;
    line-height: .35rem;
  }
  .myDialog{
    width: 405px;
    background: #fff;
    border-radius:4px;
    padding: 0 24px 24px;
    box-sizing: border-box;
    .van-dialog__header{
      font-size:20px;
      font-weight:bold;
      color:#333;
      line-height:26px;
    }
    .van-dialog__message{
      font-size:16px;
      color:#333;
      line-height:21px;
      padding: 24px 0 36px;
    }
    .van-dialog__footer{
      overflow: initial;
    }
    .van-dialog__footer--buttons{
      justify-content: space-between;
    }
    .van-button--large{
      flex: none;
      width: 160px;
      height: 48px;
      line-height: 48px;
    }
    .van-dialog__cancel{
      border-radius:2px;
      border:1px solid #F57523;
      font-size:16px;
      color: #F57523;
    }
    .van-dialog__confirm{
      background: #F57523;
      border-radius:2px;
      font-size:16px;
      color: #fff;
    }
    .van-hairline--top::after{
      border: none;
    }
  }
  .myDialogMob{
    width: 5.7rem;
    padding: 0 .3rem .48rem;
    border-radius: .04rem;
    box-sizing: border-box;
    .van-dialog__header{
      padding-top: .36rem;
      font-size: .34rem;
      font-weight:bold;
      color:#333;
      line-height: .45rem;
    }
    .van-dialog__message{
      font-size: .26rem;
      color:#333;
      line-height: .35rem;
      padding: .24rem 0 .48rem;
    }
    .van-dialog__footer{
      overflow: initial;
    }
    .van-dialog__footer--buttons{
      justify-content: space-between;
    }
    .van-button--large{
      flex: none;
      width: 2.36rem;
      height: .88rem;
      line-height: .88px;
    }
    .van-dialog__cancel{
      border-radius: .02rem;
      border:1px solid #F57523;
      font-size: .3rem;
      color: #F57523;
    }
    .van-dialog__confirm{
      height: .88rem;
      background: #F57523;
      border-radius: .02rem;
      font-size: .3rem;
      color: #fff;
      box-sizing: border-box;
    }
    .van-hairline--top::after{
      border: none;
    }
  }
</style>
